import { Theme } from '@mui/material/styles';

import { BerrySeam, SchemePalettes } from '@zercode/theme';

// Berry's OWN theme builders — wrapped, not forked [STD-FE]. This is the only
// place the app hands Berry internals to @zercode/theme; branding colors from
// the Control Plane are overlaid on top of buildPalette's output.
import { buildPalette } from 'berry/themes/palette';
import BerryTypography from 'berry/themes/typography';
import BerryCustomShadows from 'berry/themes/custom-shadows';
import componentsOverrides from 'berry/themes/overrides';

export const berrySeam: BerrySeam = {
  buildBasePalette: () => buildPalette('default') as unknown as SchemePalettes,
  // casts bridge Berry's narrower param types (FontFamily union, ThemeMode enum)
  typography: (fontFamily) => BerryTypography(fontFamily as never) as unknown as Record<string, unknown>,
  customShadows: (palette, mode) => BerryCustomShadows(palette as never, mode as never) as unknown as Record<string, unknown>,
  componentsOverrides: (theme, borderRadius, outlinedFilled) =>
    componentsOverrides(theme, borderRadius, outlinedFilled) as Theme['components']
};
